import React from "react";
import Flex from "../Flex/Flex";
import { Checkbox, Radio } from "../form";
import { useFiltersContext } from "./FiltersContext";
import * as S from "./styled";
import { IFilterDropdownProps, IFilterProps } from "./types";

const FilterOptions = <TQuery extends string>({
    filters,
    handleSelectAll,
    handleSelectNone,
    iconType
}: IFilterDropdownProps<TQuery>) => {
    const { query, renderFilters } = useFiltersContext<TQuery>();

    const filterType: "checkbox" | "radio" =
        handleSelectAll || handleSelectNone || iconType === "checkbox" ? "checkbox" : "radio";

    const handleClick = (
        filter: IFilterProps<TQuery>,
        event?: React.MouseEvent<HTMLElement> | React.ChangeEvent<HTMLInputElement>
    ) => {
        if (event?.defaultPrevented) return;
        event?.preventDefault();

        const { isAll, checked, onClick } = filter;

        if (isAll) {
            checked ? handleSelectNone?.() : handleSelectAll?.();
            return;
        }

        onClick?.();
    };

    React.useEffect(() => {
        filters.forEach(filter => {
            if (!filter.checked) {
                filter.nestedFilters?.forEach(nestedFilter => {
                    if (query.getAll(nestedFilter.name).length) {
                        query.del(nestedFilter.name);
                    }
                });
            }
        });
    }, [filters]);

    return (
        <Flex column spacing={1.5}>
            {filters.map(filter => (
                <Flex column width="100%" key={filter.value}>
                    <S.FilterOptionButton onClick={e => handleClick(filter, e)}>
                        {filterType === "checkbox" ? (
                            <Checkbox
                                checked={filter.checked}
                                label={filter.label}
                                trackName="checkbox"
                                onChange={(_, e) => handleClick(filter, e)}
                            />
                        ) : (
                            <Radio
                                checked={filter.checked}
                                label={filter.label}
                                trackName="radio"
                                onChange={(_, e) => handleClick(filter, e)}
                            />
                        )}
                    </S.FilterOptionButton>
                    {filter.nestedFilters && filter.checked && (
                        <S.FilterOptionNestedFilters>{renderFilters(filter.nestedFilters)}</S.FilterOptionNestedFilters>
                    )}
                </Flex>
            ))}
        </Flex>
    );
};

export default FilterOptions;
